import Vue from 'vue';
import Store from '@app/store';
export default Vue.extend({
    data: function () { return ({
        dropdownIsOpen: false,
    }); },
    mounted: function () {
        var _this = this;
        document.body.addEventListener('click', function () { return _this.dropdownIsOpen = false; });
    },
    computed: {
        languages: function () {
            return Store.STATE.languages;
        },
        activeLanguage: function () {
            return Store.GETTERS.activeLanguage();
        },
    },
});
